<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M349 1174 l-35 -78 -23 37 c-21 34 -27 38 -60 35 -44 -4 -48 -22 -6
-26 23 -2 37 -14 60 -48 17 -24 33 -44 36 -44 3 0 16 25 28 55 13 30 26 55 31
55 4 0 10 -18 14 -40 3 -22 10 -40 14 -40 5 0 21 14 37 30 l29 30 203 0 c174
0 203 2 203 15 0 13 -29 15 -204 15 -189 0 -205 -1 -229 -20 l-26 -21 -11 43
c-22 86 -23 86 -61 2z"
      />
      <path
        d="M419 877 l-56 -122 25 -3 c15 -2 31 3 38 12 15 21 92 22 100 1 6 -16
64 -21 64 -6 0 10 -108 241 -112 241 -2 0 -28 -55 -59 -123z m107 -13 c24 -53
43 -98 41 -100 -2 -2 -14 5 -27 16 -31 27 -100 27 -125 0 -10 -11 -20 -18 -23
-15 -5 4 79 194 86 195 2 0 23 -43 48 -96z"
      />
      <path
        d="M457 875 c-24 -50 -22 -55 23 -55 22 0 40 2 40 5 0 8 -40 85 -43 85
-2 0 -11 -16 -20 -35z m33 -26 c0 -5 -7 -9 -15 -9 -9 0 -12 6 -9 15 6 15 24
11 24 -6z"
      />
      <path
        d="M643 985 c-60 -26 -69 -92 -15 -118 38 -20 82 -29 82 -18 0 10 -24
21 -49 21 -29 0 -54 35 -47 64 8 33 40 49 82 41 53 -10 44 -30 -12 -26 -11 1
-27 -5 -34 -15 -12 -14 -12 -18 5 -30 10 -8 35 -14 54 -14 27 0 32 3 21 10 -8
5 -25 10 -37 10 -12 0 -25 5 -29 11 -5 8 1 10 19 7 15 -3 37 2 53 12 l26 18
-23 15 c-38 24 -62 27 -96 12z"
      />
      <path
        d="M154 977 c-2 -7 -3 -60 -2 -118 l3 -104 28 -3 c26 -3 27 -2 27 47 l0
51 40 0 40 0 0 -50 c0 -49 1 -50 30 -50 l30 0 0 121 0 120 -27 -3 c-25 -3 -28
-7 -31 -46 -3 -43 -3 -43 -40 -40 -36 3 -37 4 -40 46 -3 37 -6 42 -28 42 -13
0 -27 -6 -30 -13z m46 -47 l0 -40 55 0 55 0 0 40 c0 22 5 40 10 40 6 0 10 -40
10 -100 0 -60 -4 -100 -10 -100 -5 0 -10 20 -10 45 0 39 -3 45 -24 51 -13 3
-37 4 -52 2 -27 -3 -29 -6 -32 -50 -2 -34 -7 -48 -18 -48 -11 0 -14 19 -14
100 0 82 3 100 15 100 11 0 15 -11 15 -40z"
      />
      <path
        d="M850 965 c-136 -61 -178 -234 -83 -344 53 -63 102 -84 184 -79 89 5
142 39 182 117 36 73 36 131 -1 202 -41 78 -94 113 -180 116 -45 2 -79 -2
-102 -12z m178 -42 c53 -28 93 -96 94 -160 1 -162 -180 -249 -304 -145 -63 53
-83 143 -49 217 47 102 158 140 259 88z"
      />
      <path
        d="M924 917 c-9 -24 0 -52 16 -52 21 0 24 39 6 55 -13 10 -17 9 -22 -3z"
      />
      <path
        d="M824 866 c-8 -21 3 -36 27 -36 25 0 25 26 -1 40 -16 9 -22 8 -26 -4z"
      />
      <path
        d="M1010 860 c-9 -16 -8 -22 6 -27 18 -7 48 23 38 38 -9 16 -33 9 -44
-11z"
      />
      <path
        d="M970 790 c-57 -18 -73 -42 -32 -48 12 -2 22 1 22 6 0 5 16 17 35 28
19 10 35 22 35 26 0 5 -1 8 -2 7 -2 -1 -28 -9 -58 -19z"
      />
      <path
        d="M787 773 c-15 -14 -6 -33 16 -33 29 0 37 7 30 26 -5 14 -35 19 -46 7z"
      />
      <path
        d="M1042 763 c4 -22 34 -29 53 -13 21 17 9 30 -26 30 -24 0 -30 -4 -27
-17z"
      />
      <path
        d="M618 812 c-16 -9 -28 -20 -28 -24 0 -14 61 -39 83 -35 18 3 17 5 -11
12 -18 4 -35 12 -38 17 -10 16 18 28 39 16 13 -7 22 -7 30 1 8 8 5 11 -9 11
-11 0 -24 4 -29 9 -6 6 -20 4 -37 -7z"
      />
      <path
        d="M285 711 c-67 -31 -115 -102 -115 -171 l0 -30 61 0 c56 0 63 2 94 35
30 33 35 35 59 24 19 -9 30 -24 37 -56 11 -42 22 -53 34 -33 3 6 30 10 60 10
30 0 66 5 80 12 22 10 30 8 53 -9 39 -29 41 -74 5 -102 -18 -15 -34 -20 -48
-16 -11 4 -34 9 -52 12 -30 5 -32 3 -54 -57 -28 -76 -57 -100 -93 -76 -13 8
-27 30 -31 48 -4 18 -11 43 -16 56 -8 22 -10 22 -33 7 -27 -18 -57 -9 -74 21
-5 9 -14 15 -20 13 -5 -2 50 -70 124 -151 157 -172 166 -176 244 -109 l45 39
50 -53 c71 -73 124 -99 205 -100 77 0 122 22 151 75 10 19 29 47 40 61 61 77
30 249 -45 249 -12 0 -33 -12 -47 -26 -22 -23 -24 -34 -24 -114 0 -78 -2 -90
-19 -94 -26 -7 -10 -26 22 -26 50 0 57 -14 24 -50 -25 -29 -36 -34 -89 -38
-47 -3 -68 0 -102 18 -46 23 -132 104 -130 123 0 7 46 52 100 101 98 87 120
115 133 168 6 25 3 27 -50 43 -70 20 -134 77 -163 145 l-22 50 -37 -16 c-20
-8 -49 -27 -65 -41 l-27 -27 -38 37 c-68 66 -150 84 -227 48z m779 -327 c16
-6 23 -34 8 -34 -10 0 -32 22 -32 32 0 10 3 10 24 2z"
      />
      <path
        d="M330 495 c-24 -45 -35 -54 -42 -36 -3 11 -145 18 -154 8 -16 -15 13
-27 66 -27 52 0 60 -3 78 -27 16 -23 22 -25 35 -15 8 7 20 26 27 42 7 17 15
30 19 30 3 0 17 -42 31 -93 31 -114 45 -118 80 -23 l25 68 67 -5 c51 -4 69 -2
79 9 8 10 9 17 0 28 -13 15 -148 11 -166 -5 -5 -5 -17 -29 -26 -52 l-17 -42
-21 75 c-12 41 -25 83 -27 93 -9 29 -28 19 -54 -28z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
